/* MUI */
import { Button, FormLabel, Grid, TextField } from '@mui/material';

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
// Modals are imported directly here due to a circular dependency.
import { Modal } from 'application/Shared/Modals/Components/Modal';
import { ModalBody } from 'application/Shared/Modals/Components/ModalBody';
import { ModalFooter } from 'application/Shared/Modals/Components/ModalFooter';

/* Hooks */
import {
    usePostPublisher,
    usePutPublisher
} from 'hooks/dataAccess/Publisher/publisher';

/*  React  */
import React, { useState } from 'react';

/* React */
import { useTranslation } from 'react-i18next';

const createPublisher = async ({
    description,
    editingRow,
    name,
    postPublisher,
    putPublisher,
    t
}) => {
    if (!name) {
        Notify.e(t('GlobalAdmin.Publisher.create.fieldErrors.name'));
        return false;
    }
    let result;
    if (editingRow) {
        result = await putPublisher({
            description,
            id: editingRow.id,
            name
        });
    } else {
        result = await postPublisher({ description, name });
    }
    return result;
};

const onSubmit = async ({
    description,
    editingRow,
    name,
    onModalClose,
    onSuccessFn,
    postPublisher,
    putPublisher,
    t
}) => {
    const tenantId = await createPublisher({
        description,
        editingRow,
        name,
        postPublisher,
        putPublisher,
        t
    });

    if (!tenantId) {
        return;
    }

    if (onSuccessFn) onSuccessFn(tenantId);

    onModalClose();
};

export const CreatePublisherModal = ({
    editingRow,
    onClose,
    open,
    onSuccessFn
}) => {
    const { t } = useTranslation();
    const [name, setName] = useState(editingRow?.name || '');
    const [description, setDescription] = useState(
        editingRow?.description || ''
    );
    const { postPublisher } = usePostPublisher(t);
    const { putPublisher } = usePutPublisher(t);

    const resetForm = () => {
        setName('');
        setDescription('');
    };
    const onModalClose = () => {
        resetForm();
        onClose();
    };
    return (
        <Modal
            open={open}
            onClose={onModalClose}
            title={
                editingRow
                    ? t('GlobalAdmin.Publisher.editPublisher')
                    : t('GlobalAdmin.Publisher.create')
            }
        >
            <>
                <ModalBody style={{ marginTop: '16px' }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <FormLabel component="label">
                                {t('GlobalAdmin.Publisher.create.name')}
                            </FormLabel>
                            <TextField
                                autoFocus
                                onChange={(e) => setName(e.target.value)}
                                fullWidth
                                placeholder={t('Common.name')}
                                required
                                value={name}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel component="label">
                                {t('Common.description')}
                            </FormLabel>
                            <TextField
                                fullWidth
                                onChange={(e) => setDescription(e.target.value)}
                                type="text"
                                value={description}
                            />
                        </Grid>
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <Button
                        data-trackid="globalAdmin_apps_createPublisher_cancel"
                        onClick={onModalClose}
                        color="secondary"
                        variant="contained"
                    >
                        {t('Common.cancel')}
                    </Button>
                    <Button
                        data-trackid="globalAdmin_apps_createPublisher_saveCreate"
                        variant="contained"
                        onClick={async () => {
                            await onSubmit({
                                description,
                                editingRow,
                                name,
                                onModalClose,
                                onSuccessFn,
                                postPublisher,
                                putPublisher,
                                t
                            });
                        }}
                        color="primary"
                    >
                        {editingRow ? t('Common.save') : t('Common.create')}
                    </Button>
                </ModalFooter>
            </>
        </Modal>
    );
};
